import React, { useState, useEffect } from 'react';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import rrulePlugin from '@fullcalendar/rrule'
import './Schedules.css';
import '../../pages/SchedulePage/Schedule.css';
import NoticeBoard from '../notice-board/NoticeBoard';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import LessonService from '../../services/LessonService';
import { message } from 'antd';
import moment from 'moment';

import { Link } from "react-router-dom";
import ResponsiveBreadcrumb from '../breadcrumb/ResponsiveBreadcrumb';

//import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
// import NoticeBoardList from '../notice-board/NoticeBoardList';
import { Tooltip } from "bootstrap";
import * as AntDIcons from '@ant-design/icons';

let tooltipInstance = null;

export default function Schedules() {
   const [userSchedule, setUserSchedule] = useState([]);

   useEffect(() => {
      //setCurrentUsername(Utils.getCurrentUserInfo(Enums.UserInfo.fullname));
      Utils.verifyJwt();

      let user = Utils.getCurrentUserInfo(Enums.UserInfo.id);
      let role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

      //-- ToDo: If parent account, get child user id

      LessonService.getUserSchedule(user, role).then((schedules) => {
         var data = schedules.data
         let tmpSchedule = []
         data.map((item) => {
            var learningtype = item.learningType === "async" ? "Asynchronous" : "Synchronous"
            var rr = { freq: "weekly", byweekday: ["mo", "tu", "we", "th", "fr", "sa"], dtstart: moment(item.availabilityFromDate).format("YYYY-MM-DD HH:mm:ss"), until: moment(item.availabilityToDate).format("YYYY-MM-DD HH:mm:ss") }
            var titleDescription = `${item.lesson_Title} | ${learningtype}`
            var schedule = { title: titleDescription, rrule: rr }
            tmpSchedule.push(schedule)
         })
         setUserSchedule(tmpSchedule)
         // message.info("Calendar Loaded")
      }).catch((ex) => {
         message.error(ex.message)
      })
      Utils.getCurrentUserInfo(Enums.UserInfo.role)
   }, []);

   // actions
   const handleMouseEnter = (info) => {
      if (info.event.title) {
         tooltipInstance = new Tooltip(info.el, {
            title: info.event.title,
            html: true,
            placement: "top",
            trigger: "hover",
            container: "body"
         });

         tooltipInstance.show();
      }
   };

   const handleMouseLeave = (info) => {
      if (tooltipInstance) {
         tooltipInstance.dispose();
         tooltipInstance = null;
      }
   };

   return (
      <>
         <div className="dashboard-area-all schedule-page" >
            <div className="dashboard-item schedule-shell">
               <div className="schedule-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'schedule-calendar', node: 'Schedule Calendar' },
                     ]}
                  />
               </div>
               <section className="schedule-overview">
                  <div>
                     <span className="schedule-kicker">Schedule</span>
                     <h1>Schedule Calendar</h1>
                     <p>Review scheduled lessons and class activities in a calendar view.</p>
                     <div className="schedule-meta">
                        <span><AntDIcons.CalendarOutlined /> {userSchedule.length} scheduled item{userSchedule.length === 1 ? '' : 's'}</span>
                     </div>
                  </div>
               </section>
               <section className="schedule-panel">
                  <div className="schedule-panel-header">
                     <div>
                        <span className="schedule-kicker">Calendar</span>
                        <h2>Learning Schedule</h2>
                     </div>
                  </div>
                  <div className="schedule-calendar-shell">
                     <FullCalendar
                        defaultView="dayGridMonth"
                        eventMouseEnter={handleMouseEnter}
                        eventMouseLeave={handleMouseLeave}
                        header={{
                           left: "prev,next",
                           center: "title",
                           right: "dayGridMonth,timeGridWeek,timeGridDay"
                        }}
                        plugins={[dayGridPlugin, timeGridPlugin, rrulePlugin]}
                        events={userSchedule}
                     />
                  </div>
               </section>
            </div>
         </div>
         <div className="notice-area">
            <div className="notice-item">
               {/* <SideCalendar /> */}
               <NoticeBoard />
               {/* <NoticeBoardList/> */}
            </div>
         </div>
      </>
   )
}
